// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WE2 P4-08: Drawing dock and inspector styles.
 */

/* ── Legacy Drawing Dock classes removed (P2.2 cleanup). ────────────── */
/* Only \`.vnsc-drawing-dock__empty\` retained — still used in DrawingWorkspace.tsx:176 */
.vnsc-drawing-dock__empty {
	padding: 16px;
	text-align: center;
	color: var(--vnsc-text-muted, #606060);
}

/* ── Point Legend ─────────────────────────────────────────────────── */
.vnsc-drawing-point-legend {
	padding: 8px;
	border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}

.vnsc-drawing-point-legend__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 4px;
}

.vnsc-drawing-point-legend__item {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 4px 6px;
	border-radius: var(--vnsc-radius-sm, 3px);
	cursor: pointer;
	transition: background var(--vnsc-transition-fast);
}

.vnsc-drawing-point-legend__item:hover,
.vnsc-drawing-point-legend__item--active {
	background: var(--vnsc-bg-tertiary, #1a1a1a);
}

.vnsc-drawing-point-legend__index {
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background: var(--vnsc-accent, #2962ff);
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: var(--vnsc-font-xs, 10px);
	font-weight: 700;
}

.vnsc-drawing-point-legend__label {
	font-size: var(--vnsc-font-sm, 11px);
	color: var(--vnsc-text-secondary, #a0a0a0);
}

/* ── Storage Toolbar ──────────────────────────────────────────────── */
.vnsc-drawing-storage-toolbar {
	display: flex;
	gap: 4px;
	padding: 4px 8px;
	border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}

.vnsc-drawing-storage-toolbar__button {
	padding: 4px 8px;
	border: none;
	border-radius: var(--vnsc-radius-sm, 3px);
	background: transparent;
	color: var(--vnsc-text-secondary, #a0a0a0);
	cursor: pointer;
	font-size: var(--vnsc-font-sm, 11px);
	transition: background var(--vnsc-transition-fast);
}

.vnsc-drawing-storage-toolbar__button:hover {
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	color: var(--vnsc-text-primary, #e0e0e0);
}

/* ── Paper Trade Panel ────────────────────────────────────────────── */
.vnsc-paper-trade-panel {
	position: absolute;
	right: 0;
	top: 0;
	bottom: 0;
	width: 280px;
	background: var(--vnsc-bg-primary, #0a0e14);
	border-left: 1px solid var(--vnsc-border, #2a2a2a);
	z-index: 50;
	display: flex;
	flex-direction: column;
	font-size: var(--vnsc-font-sm, 11px);
	color: var(--vnsc-text-primary, #e0e0e0);
	overflow: hidden;
}

.vnsc-paper-trade-panel__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}

.vnsc-paper-trade-panel__close-btn {
	appearance: none;
	border: none;
	background: transparent;
	color: var(--vnsc-text-secondary, #a0a0a0);
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: var(--vnsc-font-lg, 14px);
	cursor: pointer;
	padding: 0;
	transition: color var(--vnsc-transition-fast, 120ms);
}

.vnsc-paper-trade-panel__close-btn:hover {
	color: var(--vnsc-text-primary, #e0e0e0);
}

.vnsc-paper-trade-panel__stats {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 4px;
	padding: 8px 12px;
	border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}

.vnsc-paper-trade-panel__stat-label {
	font-size: var(--vnsc-font-xs, 10px);
	color: var(--vnsc-text-secondary, #a0a0a0);
}

.vnsc-paper-trade-panel__stat-value {
	font-weight: 700;
	font-size: var(--vnsc-font-md, 13px);
}

.vnsc-paper-trade-panel__position {
	padding: 8px 12px;
	border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}

.vnsc-paper-trade-panel__position-badge {
	padding: 2px 6px;
	border-radius: var(--vnsc-radius-sm, 3px);
	font-size: var(--vnsc-font-xs, 10px);
	font-weight: 700;
	color: #fff;
}

.vnsc-paper-trade-panel__position-badge--long {
	background: #0d6b2e;
}

.vnsc-paper-trade-panel__position-badge--short {
	background: #c0392b;
}

.vnsc-paper-trade-panel__journal {
	flex: 1;
	overflow-y: auto;
	padding: 8px 12px;
}

.vnsc-paper-trade-panel__journal-item {
	display: flex;
	justify-content: space-between;
	padding: 4px 0;
	border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}

.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-pnl {
	color: #089981;
}

.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-pnl {
	color: #f23645;
}

/* ── Drawing Inspector & List Panel ────────────────────────────────── */
.vnsc-drawing-inspector,
.vnsc-drawing-list-panel {
	width: min(348px, calc(100vw - 32px));
	border-radius: var(--vnsc-radius-md, 4px);
	border: 1px solid var(--vnsc-border, #2a2a2a);
	background: var(--vnsc-bg-secondary, #111820);
	box-shadow: var(--vnsc-shadow-lg, 0 8px 32px rgba(0, 0, 0, 0.4));
	color: var(--vnsc-text-primary, #e0e0e0);
	padding: 14px;
	display: grid;
	gap: 14px;
	max-height: calc(100% - 32px);
	overflow: auto;
	overscroll-behavior: contain;
}

.vnsc-drawing-inspector--embedded,
.vnsc-drawing-list-panel--embedded {
	position: static;
	z-index: auto;
	width: auto;
	max-height: none;
	overflow: visible;
	padding: 0;
	border: none;
	background: transparent;
	box-shadow: none;
	backdrop-filter: none;
	-webkit-backdrop-filter: none;
}

.vnsc-drawing-inspector--embedded .vnsc-drawing-inspector__header,
.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__header {
	display: none;
}

.vnsc-drawing-inspector__header,
.vnsc-drawing-list-panel__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
}

.vnsc-drawing-inspector__title {
	display: grid;
	gap: 4px;
	min-width: 0;
}

.vnsc-drawing-inspector__title strong,
.vnsc-drawing-list-panel__header strong {
	font-size: 13px;
	font-weight: 700;
	color: var(--vnsc-text-primary, #e0e0e0);
	letter-spacing: 0.01em;
}

.vnsc-drawing-inspector__title span,
.vnsc-drawing-list-panel__header span {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.1em;
	color: var(--vnsc-text-muted, #606060);
}

.vnsc-drawing-inspector__icon,
.vnsc-drawing-list-panel__icon {
	appearance: none;
	border: 1px solid var(--vnsc-border, #2a2a2a);
	background: transparent;
	color: var(--vnsc-text-secondary, #a0a0a0);
	width: 28px;
	height: 28px;
	border-radius: var(--vnsc-radius-sm, 3px);
	cursor: pointer;
	transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);
}

.vnsc-drawing-inspector__icon:hover,
.vnsc-drawing-list-panel__icon:hover {
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	border-color: var(--vnsc-border, #2a2a2a);
	color: var(--vnsc-text-primary, #e0e0e0);
}

.vnsc-drawing-inspector__swatches {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px;
}

.vnsc-drawing-inspector__field {
	display: grid;
	gap: 8px;
	color: var(--vnsc-text-secondary, #a0a0a0);
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.06em;
	text-transform: uppercase;
}

.vnsc-drawing-inspector__field label {
	display: grid;
	gap: 8px;
}

.vnsc-drawing-inspector__field input[type="color"] {
	appearance: none;
	width: 100%;
	height: 36px;
	border: 1px solid var(--vnsc-border, #2a2a2a);
	border-radius: var(--vnsc-radius-sm, 3px);
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	padding: 3px;
	cursor: pointer;
}

.vnsc-drawing-inspector__field input[type="range"] {
	width: 100%;
	accent-color: var(--vnsc-accent, #2962ff);
}

.vnsc-drawing-inspector__field select {
	appearance: none;
	width: 100%;
	border: 1px solid var(--vnsc-border, #2a2a2a);
	border-radius: var(--vnsc-radius-sm, 3px);
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	color: var(--vnsc-text-primary, #e0e0e0);
	padding: 8px 10px;
	font-size: 12px;
}

.vnsc-drawing-inspector__actions {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 8px;
}

.vnsc-drawing-inspector__button {
	appearance: none;
	border: 1px solid var(--vnsc-border, #2a2a2a);
	background: transparent;
	color: var(--vnsc-text-secondary, #a0a0a0);
	border-radius: var(--vnsc-radius-sm, 3px);
	padding: 8px 10px;
	font-size: 11.5px;
	font-weight: 600;
	cursor: pointer;
	transition: background var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast), color var(--vnsc-transition-fast);
}

.vnsc-drawing-inspector__button:hover {
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	border-color: var(--vnsc-border, #2a2a2a);
	color: var(--vnsc-text-primary, #e0e0e0);
}

.vnsc-drawing-inspector__button:disabled {
	opacity: 0.42;
	cursor: default;
	transform: none;
}

.vnsc-drawing-inspector__button--danger {
	grid-column: 1 / -1;
	border-color: rgba(239, 68, 68, 0.28);
	background: rgba(239, 68, 68, 0.1);
	color: #fecaca;
}

.vnsc-drawing-inspector__button--danger:hover {
	background: rgba(239, 68, 68, 0.18);
	border-color: rgba(239, 68, 68, 0.38);
	color: #fff1f2;
}

/* Drawing list panel: flex layout with sticky header + scrollable items */
.vnsc-drawing-list-panel {
	display: flex;
	flex-direction: column;
	max-height: min(560px, calc(100vh - 160px));
	overflow: hidden;
	padding: 0;
	gap: 0;
}

.vnsc-drawing-list-panel--embedded {
	gap: 0;
	max-height: none;
	min-height: 0;
}

.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__items {
	padding: 0;
}

.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__empty {
	margin: 0;
}

.vnsc-drawing-list-panel__header {
	flex-shrink: 0;
	padding: 12px 14px;
	border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.vnsc-drawing-list-panel__count {
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	padding: 2px 6px;
	border-radius: 999px;
	font-size: var(--vnsc-font-xs, 10px);
	font-weight: 700;
	color: var(--vnsc-text-secondary, #a0a0a0);
}

.vnsc-drawing-list-panel__search {
	padding: 8px 14px;
	border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}

.vnsc-drawing-list-panel__search-input {
	width: 100%;
	padding: 6px 10px;
	border-radius: var(--vnsc-radius-sm, 3px);
	border: 1px solid var(--vnsc-border, #2a2a2a);
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	color: var(--vnsc-text-primary, #e0e0e0);
	font-size: var(--vnsc-font-sm, 11px);
	outline: none;
}

.vnsc-drawing-list-panel__search-input:focus {
	border-color: var(--vnsc-accent, #2962ff);
}

.vnsc-drawing-list-panel__items {
	display: grid;
	gap: 8px;
	overflow-y: auto;
	overflow-x: hidden;
	overscroll-behavior: contain;
	flex: 1 1 auto;
	min-height: 0;
	padding: 10px 14px 12px;
	scrollbar-width: thin;
	scrollbar-color: var(--vnsc-border, #2a2a2a) transparent;
}

.vnsc-drawing-list-panel__items::-webkit-scrollbar {
	width: 4px;
}

.vnsc-drawing-list-panel__items::-webkit-scrollbar-track {
	background: transparent;
}

.vnsc-drawing-list-panel__items::-webkit-scrollbar-thumb {
	background: var(--vnsc-border, #2a2a2a);
	border-radius: 4px;
}

.vnsc-drawing-list-panel__empty {
	margin: 10px 14px 12px;
	padding: 16px 14px;
	border-radius: var(--vnsc-radius-md, 4px);
	border: 1px dashed var(--vnsc-border, #2a2a2a);
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	color: var(--vnsc-text-secondary, #a0a0a0);
	font-size: 13px;
	line-height: 1.5;
}

.vnsc-drawing-list-panel__group {
	display: grid;
	gap: 6px;
	margin-bottom: 8px;
}

.vnsc-drawing-list-panel__group-header {
	display: flex;
	align-items: center;
	gap: 6px;
	width: 100%;
	padding: 6px 8px;
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	border: 1px solid var(--vnsc-border, #2a2a2a);
	border-radius: var(--vnsc-radius-sm, 3px);
	color: var(--vnsc-text-primary, #e0e0e0);
	font-size: var(--vnsc-font-sm, 11px);
	font-weight: 700;
	cursor: pointer;
	text-align: left;
}

.vnsc-drawing-list-panel__group-caret {
	font-size: 8px;
	color: var(--vnsc-text-secondary, #a0a0a0);
}

.vnsc-drawing-list-panel__group-name {
	flex: 1;
}

.vnsc-drawing-list-panel__group-count {
	background: rgba(255, 255, 255, 0.08);
	padding: 1px 5px;
	border-radius: 999px;
	font-size: var(--vnsc-font-xs, 10px);
}

.vnsc-drawing-list-panel__item {
	display: grid;
	gap: 10px;
	padding: 12px;
	border-radius: var(--vnsc-radius-md, 4px);
	border: 1px solid var(--vnsc-border, #2a2a2a);
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	transition: border-color 120ms ease;
}

.vnsc-drawing-list-panel__item--selected {
	border-color: var(--vnsc-accent, #2962ff);
	box-shadow: 0 0 0 1px rgba(41, 98, 255, 0.1) inset;
}

.vnsc-drawing-list-panel__item--drag-over {
	border-color: var(--vnsc-accent, #2962ff);
	border-style: dashed;
}

.vnsc-drawing-list-panel__select {
	appearance: none;
	border: none;
	background: transparent;
	padding: 0;
	text-align: left;
	cursor: pointer;
	display: grid;
	gap: 4px;
	color: inherit;
}

.vnsc-drawing-list-panel__label {
	font-size: 13px;
	font-weight: 700;
	color: var(--vnsc-text-primary, #e0e0e0);
	letter-spacing: 0.01em;
}

.vnsc-drawing-list-panel__meta {
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--vnsc-text-muted, #606060);
}

.vnsc-drawing-list-panel__actions {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	align-items: center;
}

.vnsc-drawing-list-panel__badge {
	display: inline-flex;
	align-items: center;
	padding: 4px 9px;
	border-radius: 999px;
	border: 1px solid var(--vnsc-border, #2a2a2a);
	background: var(--vnsc-bg-secondary, #111820);
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--vnsc-text-secondary, #a0a0a0);
}

.vnsc-drawing-list-panel__icon {
	width: auto;
	height: auto;
	padding: 5px 10px;
	border-radius: 999px;
	font-size: 11px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.08em;
}

.vnsc-drawing-list-panel__icon--delete {
	color: #f23645;
}

.vnsc-long-tp-zone {
	fill: rgba(34, 197, 94, 0.16);
}

.vnsc-long-sl-zone {
	fill: rgba(239, 68, 68, 0.16);
}

.vnsc-short-tp-zone {
	fill: rgba(239, 68, 68, 0.16);
}

.vnsc-short-sl-zone {
	fill: rgba(34, 197, 94, 0.16);
}

.vnsc-rr-badge {
	font-family: "Segoe UI Variable Text", "Aptos", "Segoe UI", sans-serif;
	font-size: 11px;
	font-weight: 800;
	letter-spacing: 0.08em;
	fill: #e2e8f0;
}

.vnsc-drawing-inspector__icon-grid {
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	gap: 6px;
	margin-top: 6px;
}

.vnsc-drawing-inspector__icon-cell {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 32px;
	border: 1px solid var(--vnsc-border, #2a2a2a);
	border-radius: var(--vnsc-radius-sm, 3px);
	background: var(--vnsc-bg-tertiary, #1a1a1a);
	font-size: 18px;
	cursor: pointer;
	user-select: none;
	transition: background var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);
}

.vnsc-drawing-inspector__icon-cell:hover {
	background: var(--vnsc-bg-secondary, #222222);
	border-color: var(--vnsc-accent, #2962ff);
}

.vnsc-drawing-inspector__icon-cell--selected {
	background: var(--vnsc-bg-secondary, #222222);
	border-color: var(--vnsc-accent, #2962ff);
	box-shadow: 0 0 0 1px var(--vnsc-accent, #2962ff);
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/drawing.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF,0EAA0E;AAC1E,uFAAuF;AACvF;CACC,aAAa;CACb,kBAAkB;CAClB,sCAAsC;AACvC;;AAEA,wEAAwE;AACxE;CACC,YAAY;CACZ,oDAAoD;AACrD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,gBAAgB;CAChB,yCAAyC;CACzC,eAAe;CACf,kDAAkD;AACnD;;AAEA;;CAEC,4CAA4C;AAC7C;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,uCAAuC;CACvC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,oCAAoC;CACpC,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;CACpC,0CAA0C;AAC3C;;AAEA,wEAAwE;AACxE;CACC,aAAa;CACb,QAAQ;CACR,gBAAgB;CAChB,oDAAoD;AACrD;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,yCAAyC;CACzC,uBAAuB;CACvB,0CAA0C;CAC1C,eAAe;CACf,oCAAoC;CACpC,kDAAkD;AACnD;;AAEA;CACC,4CAA4C;CAC5C,wCAAwC;AACzC;;AAEA,wEAAwE;AACxE;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,SAAS;CACT,YAAY;CACZ,2CAA2C;CAC3C,kDAAkD;CAClD,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,oCAAoC;CACpC,wCAAwC;CACxC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,iBAAiB;CACjB,oDAAoD;AACrD;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,uBAAuB;CACvB,0CAA0C;CAC1C,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,oCAAoC;CACpC,eAAe;CACf,UAAU;CACV,oDAAoD;AACrD;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,QAAQ;CACR,iBAAiB;CACjB,oDAAoD;AACrD;;AAEA;CACC,oCAAoC;CACpC,0CAA0C;AAC3C;;AAEA;CACC,gBAAgB;CAChB,oCAAoC;AACrC;;AAEA;CACC,iBAAiB;CACjB,oDAAoD;AACrD;;AAEA;CACC,gBAAgB;CAChB,yCAAyC;CACzC,oCAAoC;CACpC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,OAAO;CACP,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,cAAc;CACd,oDAAoD;AACrD;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA,yEAAyE;AACzE;;CAEC,qCAAqC;CACrC,yCAAyC;CACzC,6CAA6C;CAC7C,6CAA6C;CAC7C,gEAAgE;CAChE,wCAAwC;CACxC,aAAa;CACb,aAAa;CACb,SAAS;CACT,6BAA6B;CAC7B,cAAc;CACd,4BAA4B;AAC7B;;AAEA;;CAEC,gBAAgB;CAChB,aAAa;CACb,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,UAAU;CACV,YAAY;CACZ,uBAAuB;CACvB,gBAAgB;CAChB,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;;CAEC,aAAa;AACd;;AAEA;;CAEC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,YAAY;AACb;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB,wCAAwC;CACxC,sBAAsB;AACvB;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,qBAAqB;CACrB,sCAAsC;AACvC;;AAEA;;CAEC,gBAAgB;CAChB,6CAA6C;CAC7C,uBAAuB;CACvB,0CAA0C;CAC1C,WAAW;CACX,YAAY;CACZ,yCAAyC;CACzC,eAAe;CACf,+HAA+H;AAChI;;AAEA;;CAEC,4CAA4C;CAC5C,yCAAyC;CACzC,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,gDAAgD;CAChD,SAAS;AACV;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,0CAA0C;CAC1C,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,6CAA6C;CAC7C,yCAAyC;CACzC,4CAA4C;CAC5C,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,yCAAyC;AAC1C;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,6CAA6C;CAC7C,yCAAyC;CACzC,4CAA4C;CAC5C,wCAAwC;CACxC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,gDAAgD;CAChD,QAAQ;AACT;;AAEA;CACC,gBAAgB;CAChB,6CAA6C;CAC7C,uBAAuB;CACvB,0CAA0C;CAC1C,yCAAyC;CACzC,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,+HAA+H;AAChI;;AAEA;CACC,4CAA4C;CAC5C,yCAAyC;CACzC,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,qCAAqC;CACrC,kCAAkC;CAClC,cAAc;AACf;;AAEA;CACC,mCAAmC;CACnC,qCAAqC;CACrC,cAAc;AACf;;AAEA,0EAA0E;AAC1E;CACC,aAAa;CACb,sBAAsB;CACtB,2CAA2C;CAC3C,gBAAgB;CAChB,UAAU;CACV,MAAM;AACP;;AAEA;CACC,MAAM;CACN,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,oDAAoD;CACpD,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,4CAA4C;CAC5C,gBAAgB;CAChB,oBAAoB;CACpB,oCAAoC;CACpC,gBAAgB;CAChB,0CAA0C;AAC3C;;AAEA;CACC,iBAAiB;CACjB,oDAAoD;AACrD;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,yCAAyC;CACzC,6CAA6C;CAC7C,4CAA4C;CAC5C,wCAAwC;CACxC,oCAAoC;CACpC,aAAa;AACd;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,gBAAgB;CAChB,kBAAkB;CAClB,4BAA4B;CAC5B,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,qBAAqB;CACrB,wDAAwD;AACzD;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,yCAAyC;CACzC,8CAA8C;CAC9C,4CAA4C;CAC5C,0CAA0C;CAC1C,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,WAAW;CACX,gBAAgB;CAChB,4CAA4C;CAC5C,6CAA6C;CAC7C,yCAAyC;CACzC,wCAAwC;CACxC,oCAAoC;CACpC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,0CAA0C;AAC3C;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;CAChB,oBAAoB;CACpB,oCAAoC;AACrC;;AAEA;CACC,aAAa;CACb,SAAS;CACT,aAAa;CACb,yCAAyC;CACzC,6CAA6C;CAC7C,4CAA4C;CAC5C,mCAAmC;AACpC;;AAEA;CACC,yCAAyC;CACzC,kDAAkD;AACnD;;AAEA;CACC,yCAAyC;CACzC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,uBAAuB;CACvB,UAAU;CACV,gBAAgB;CAChB,eAAe;CACf,aAAa;CACb,QAAQ;CACR,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wCAAwC;CACxC,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,sCAAsC;AACvC;;AAEA;CACC,aAAa;CACb,eAAe;CACf,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,oBAAoB;CACpB,6CAA6C;CAC7C,6CAA6C;CAC7C,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,0CAA0C;AAC3C;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,sEAAsE;CACtE,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,6CAA6C;CAC7C,yCAAyC;CACzC,4CAA4C;CAC5C,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,4FAA4F;AAC7F;;AAEA;CACC,6CAA6C;CAC7C,yCAAyC;AAC1C;;AAEA;CACC,6CAA6C;CAC7C,yCAAyC;CACzC,iDAAiD;AAClD","sourcesContent":["/**\r\n * WE2 P4-08: Drawing dock and inspector styles.\r\n */\r\n\r\n/* ── Legacy Drawing Dock classes removed (P2.2 cleanup). ────────────── */\r\n/* Only `.vnsc-drawing-dock__empty` retained — still used in DrawingWorkspace.tsx:176 */\r\n.vnsc-drawing-dock__empty {\r\n\tpadding: 16px;\r\n\ttext-align: center;\r\n\tcolor: var(--vnsc-text-muted, #606060);\r\n}\r\n\r\n/* ── Point Legend ─────────────────────────────────────────────────── */\r\n.vnsc-drawing-point-legend {\r\n\tpadding: 8px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.vnsc-drawing-point-legend__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tmargin-bottom: 4px;\r\n}\r\n\r\n.vnsc-drawing-point-legend__item {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 6px;\r\n\tpadding: 4px 6px;\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tcursor: pointer;\r\n\ttransition: background var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-drawing-point-legend__item:hover,\r\n.vnsc-drawing-point-legend__item--active {\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n}\r\n\r\n.vnsc-drawing-point-legend__index {\r\n\twidth: 18px;\r\n\theight: 18px;\r\n\tborder-radius: 50%;\r\n\tbackground: var(--vnsc-accent, #2962ff);\r\n\tcolor: #fff;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tfont-size: var(--vnsc-font-xs, 10px);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.vnsc-drawing-point-legend__label {\r\n\tfont-size: var(--vnsc-font-sm, 11px);\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n/* ── Storage Toolbar ──────────────────────────────────────────────── */\r\n.vnsc-drawing-storage-toolbar {\r\n\tdisplay: flex;\r\n\tgap: 4px;\r\n\tpadding: 4px 8px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.vnsc-drawing-storage-toolbar__button {\r\n\tpadding: 4px 8px;\r\n\tborder: none;\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tcursor: pointer;\r\n\tfont-size: var(--vnsc-font-sm, 11px);\r\n\ttransition: background var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-drawing-storage-toolbar__button:hover {\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n/* ── Paper Trade Panel ────────────────────────────────────────────── */\r\n.vnsc-paper-trade-panel {\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\twidth: 280px;\r\n\tbackground: var(--vnsc-bg-primary, #0a0e14);\r\n\tborder-left: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tz-index: 50;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tfont-size: var(--vnsc-font-sm, 11px);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\toverflow: hidden;\r\n}\r\n\r\n.vnsc-paper-trade-panel__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 8px 12px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.vnsc-paper-trade-panel__close-btn {\r\n\tappearance: none;\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\twidth: 24px;\r\n\theight: 24px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tfont-size: var(--vnsc-font-lg, 14px);\r\n\tcursor: pointer;\r\n\tpadding: 0;\r\n\ttransition: color var(--vnsc-transition-fast, 120ms);\r\n}\r\n\r\n.vnsc-paper-trade-panel__close-btn:hover {\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.vnsc-paper-trade-panel__stats {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 1fr 1fr;\r\n\tgap: 4px;\r\n\tpadding: 8px 12px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.vnsc-paper-trade-panel__stat-label {\r\n\tfont-size: var(--vnsc-font-xs, 10px);\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n.vnsc-paper-trade-panel__stat-value {\r\n\tfont-weight: 700;\r\n\tfont-size: var(--vnsc-font-md, 13px);\r\n}\r\n\r\n.vnsc-paper-trade-panel__position {\r\n\tpadding: 8px 12px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.vnsc-paper-trade-panel__position-badge {\r\n\tpadding: 2px 6px;\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tfont-size: var(--vnsc-font-xs, 10px);\r\n\tfont-weight: 700;\r\n\tcolor: #fff;\r\n}\r\n\r\n.vnsc-paper-trade-panel__position-badge--long {\r\n\tbackground: #0d6b2e;\r\n}\r\n\r\n.vnsc-paper-trade-panel__position-badge--short {\r\n\tbackground: #c0392b;\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal {\r\n\tflex: 1;\r\n\toverflow-y: auto;\r\n\tpadding: 8px 12px;\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-item {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\tpadding: 4px 0;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-pnl {\r\n\tcolor: #089981;\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-pnl {\r\n\tcolor: #f23645;\r\n}\r\n\r\n/* ── Drawing Inspector & List Panel ────────────────────────────────── */\r\n.vnsc-drawing-inspector,\r\n.vnsc-drawing-list-panel {\r\n\twidth: min(348px, calc(100vw - 32px));\r\n\tborder-radius: var(--vnsc-radius-md, 4px);\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tbackground: var(--vnsc-bg-secondary, #111820);\r\n\tbox-shadow: var(--vnsc-shadow-lg, 0 8px 32px rgba(0, 0, 0, 0.4));\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tpadding: 14px;\r\n\tdisplay: grid;\r\n\tgap: 14px;\r\n\tmax-height: calc(100% - 32px);\r\n\toverflow: auto;\r\n\toverscroll-behavior: contain;\r\n}\r\n\r\n.vnsc-drawing-inspector--embedded,\r\n.vnsc-drawing-list-panel--embedded {\r\n\tposition: static;\r\n\tz-index: auto;\r\n\twidth: auto;\r\n\tmax-height: none;\r\n\toverflow: visible;\r\n\tpadding: 0;\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tbox-shadow: none;\r\n\tbackdrop-filter: none;\r\n\t-webkit-backdrop-filter: none;\r\n}\r\n\r\n.vnsc-drawing-inspector--embedded .vnsc-drawing-inspector__header,\r\n.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__header {\r\n\tdisplay: none;\r\n}\r\n\r\n.vnsc-drawing-inspector__header,\r\n.vnsc-drawing-list-panel__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tgap: 12px;\r\n}\r\n\r\n.vnsc-drawing-inspector__title {\r\n\tdisplay: grid;\r\n\tgap: 4px;\r\n\tmin-width: 0;\r\n}\r\n\r\n.vnsc-drawing-inspector__title strong,\r\n.vnsc-drawing-list-panel__header strong {\r\n\tfont-size: 13px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tletter-spacing: 0.01em;\r\n}\r\n\r\n.vnsc-drawing-inspector__title span,\r\n.vnsc-drawing-list-panel__header span {\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 0.1em;\r\n\tcolor: var(--vnsc-text-muted, #606060);\r\n}\r\n\r\n.vnsc-drawing-inspector__icon,\r\n.vnsc-drawing-list-panel__icon {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tcursor: pointer;\r\n\ttransition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-drawing-inspector__icon:hover,\r\n.vnsc-drawing-list-panel__icon:hover {\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\tborder-color: var(--vnsc-border, #2a2a2a);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.vnsc-drawing-inspector__swatches {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(2, minmax(0, 1fr));\r\n\tgap: 10px;\r\n}\r\n\r\n.vnsc-drawing-inspector__field {\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tletter-spacing: 0.06em;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.vnsc-drawing-inspector__field label {\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n}\r\n\r\n.vnsc-drawing-inspector__field input[type=\"color\"] {\r\n\tappearance: none;\r\n\twidth: 100%;\r\n\theight: 36px;\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\tpadding: 3px;\r\n\tcursor: pointer;\r\n}\r\n\r\n.vnsc-drawing-inspector__field input[type=\"range\"] {\r\n\twidth: 100%;\r\n\taccent-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.vnsc-drawing-inspector__field select {\r\n\tappearance: none;\r\n\twidth: 100%;\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tpadding: 8px 10px;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.vnsc-drawing-inspector__actions {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(2, minmax(0, 1fr));\r\n\tgap: 8px;\r\n}\r\n\r\n.vnsc-drawing-inspector__button {\r\n\tappearance: none;\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tpadding: 8px 10px;\r\n\tfont-size: 11.5px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: background var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast), color var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-drawing-inspector__button:hover {\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\tborder-color: var(--vnsc-border, #2a2a2a);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.vnsc-drawing-inspector__button:disabled {\r\n\topacity: 0.42;\r\n\tcursor: default;\r\n\ttransform: none;\r\n}\r\n\r\n.vnsc-drawing-inspector__button--danger {\r\n\tgrid-column: 1 / -1;\r\n\tborder-color: rgba(239, 68, 68, 0.28);\r\n\tbackground: rgba(239, 68, 68, 0.1);\r\n\tcolor: #fecaca;\r\n}\r\n\r\n.vnsc-drawing-inspector__button--danger:hover {\r\n\tbackground: rgba(239, 68, 68, 0.18);\r\n\tborder-color: rgba(239, 68, 68, 0.38);\r\n\tcolor: #fff1f2;\r\n}\r\n\r\n/* Drawing list panel: flex layout with sticky header + scrollable items */\r\n.vnsc-drawing-list-panel {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tmax-height: min(560px, calc(100vh - 160px));\r\n\toverflow: hidden;\r\n\tpadding: 0;\r\n\tgap: 0;\r\n}\r\n\r\n.vnsc-drawing-list-panel--embedded {\r\n\tgap: 0;\r\n\tmax-height: none;\r\n\tmin-height: 0;\r\n}\r\n\r\n.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__items {\r\n\tpadding: 0;\r\n}\r\n\r\n.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__empty {\r\n\tmargin: 0;\r\n}\r\n\r\n.vnsc-drawing-list-panel__header {\r\n\tflex-shrink: 0;\r\n\tpadding: 12px 14px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n}\r\n\r\n.vnsc-drawing-list-panel__count {\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\tpadding: 2px 6px;\r\n\tborder-radius: 999px;\r\n\tfont-size: var(--vnsc-font-xs, 10px);\r\n\tfont-weight: 700;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n.vnsc-drawing-list-panel__search {\r\n\tpadding: 8px 14px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.vnsc-drawing-list-panel__search-input {\r\n\twidth: 100%;\r\n\tpadding: 6px 10px;\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tfont-size: var(--vnsc-font-sm, 11px);\r\n\toutline: none;\r\n}\r\n\r\n.vnsc-drawing-list-panel__search-input:focus {\r\n\tborder-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.vnsc-drawing-list-panel__items {\r\n\tdisplay: grid;\r\n\tgap: 8px;\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\toverscroll-behavior: contain;\r\n\tflex: 1 1 auto;\r\n\tmin-height: 0;\r\n\tpadding: 10px 14px 12px;\r\n\tscrollbar-width: thin;\r\n\tscrollbar-color: var(--vnsc-border, #2a2a2a) transparent;\r\n}\r\n\r\n.vnsc-drawing-list-panel__items::-webkit-scrollbar {\r\n\twidth: 4px;\r\n}\r\n\r\n.vnsc-drawing-list-panel__items::-webkit-scrollbar-track {\r\n\tbackground: transparent;\r\n}\r\n\r\n.vnsc-drawing-list-panel__items::-webkit-scrollbar-thumb {\r\n\tbackground: var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: 4px;\r\n}\r\n\r\n.vnsc-drawing-list-panel__empty {\r\n\tmargin: 10px 14px 12px;\r\n\tpadding: 16px 14px;\r\n\tborder-radius: var(--vnsc-radius-md, 4px);\r\n\tborder: 1px dashed var(--vnsc-border, #2a2a2a);\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tfont-size: 13px;\r\n\tline-height: 1.5;\r\n}\r\n\r\n.vnsc-drawing-list-panel__group {\r\n\tdisplay: grid;\r\n\tgap: 6px;\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n.vnsc-drawing-list-panel__group-header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 6px;\r\n\twidth: 100%;\r\n\tpadding: 6px 8px;\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tfont-size: var(--vnsc-font-sm, 11px);\r\n\tfont-weight: 700;\r\n\tcursor: pointer;\r\n\ttext-align: left;\r\n}\r\n\r\n.vnsc-drawing-list-panel__group-caret {\r\n\tfont-size: 8px;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n.vnsc-drawing-list-panel__group-name {\r\n\tflex: 1;\r\n}\r\n\r\n.vnsc-drawing-list-panel__group-count {\r\n\tbackground: rgba(255, 255, 255, 0.08);\r\n\tpadding: 1px 5px;\r\n\tborder-radius: 999px;\r\n\tfont-size: var(--vnsc-font-xs, 10px);\r\n}\r\n\r\n.vnsc-drawing-list-panel__item {\r\n\tdisplay: grid;\r\n\tgap: 10px;\r\n\tpadding: 12px;\r\n\tborder-radius: var(--vnsc-radius-md, 4px);\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\ttransition: border-color 120ms ease;\r\n}\r\n\r\n.vnsc-drawing-list-panel__item--selected {\r\n\tborder-color: var(--vnsc-accent, #2962ff);\r\n\tbox-shadow: 0 0 0 1px rgba(41, 98, 255, 0.1) inset;\r\n}\r\n\r\n.vnsc-drawing-list-panel__item--drag-over {\r\n\tborder-color: var(--vnsc-accent, #2962ff);\r\n\tborder-style: dashed;\r\n}\r\n\r\n.vnsc-drawing-list-panel__select {\r\n\tappearance: none;\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tpadding: 0;\r\n\ttext-align: left;\r\n\tcursor: pointer;\r\n\tdisplay: grid;\r\n\tgap: 4px;\r\n\tcolor: inherit;\r\n}\r\n\r\n.vnsc-drawing-list-panel__label {\r\n\tfont-size: 13px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tletter-spacing: 0.01em;\r\n}\r\n\r\n.vnsc-drawing-list-panel__meta {\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--vnsc-text-muted, #606060);\r\n}\r\n\r\n.vnsc-drawing-list-panel__actions {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 8px;\r\n\talign-items: center;\r\n}\r\n\r\n.vnsc-drawing-list-panel__badge {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tpadding: 4px 9px;\r\n\tborder-radius: 999px;\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tbackground: var(--vnsc-bg-secondary, #111820);\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n.vnsc-drawing-list-panel__icon {\r\n\twidth: auto;\r\n\theight: auto;\r\n\tpadding: 5px 10px;\r\n\tborder-radius: 999px;\r\n\tfont-size: 11px;\r\n\tfont-weight: 700;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: 0.08em;\r\n}\r\n\r\n.vnsc-drawing-list-panel__icon--delete {\r\n\tcolor: #f23645;\r\n}\r\n\r\n.vnsc-long-tp-zone {\r\n\tfill: rgba(34, 197, 94, 0.16);\r\n}\r\n\r\n.vnsc-long-sl-zone {\r\n\tfill: rgba(239, 68, 68, 0.16);\r\n}\r\n\r\n.vnsc-short-tp-zone {\r\n\tfill: rgba(239, 68, 68, 0.16);\r\n}\r\n\r\n.vnsc-short-sl-zone {\r\n\tfill: rgba(34, 197, 94, 0.16);\r\n}\r\n\r\n.vnsc-rr-badge {\r\n\tfont-family: \"Segoe UI Variable Text\", \"Aptos\", \"Segoe UI\", sans-serif;\r\n\tfont-size: 11px;\r\n\tfont-weight: 800;\r\n\tletter-spacing: 0.08em;\r\n\tfill: #e2e8f0;\r\n}\r\n\r\n.vnsc-drawing-inspector__icon-grid {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(6, 1fr);\r\n\tgap: 6px;\r\n\tmargin-top: 6px;\r\n}\r\n\r\n.vnsc-drawing-inspector__icon-cell {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\theight: 32px;\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tbackground: var(--vnsc-bg-tertiary, #1a1a1a);\r\n\tfont-size: 18px;\r\n\tcursor: pointer;\r\n\tuser-select: none;\r\n\ttransition: background var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-drawing-inspector__icon-cell:hover {\r\n\tbackground: var(--vnsc-bg-secondary, #222222);\r\n\tborder-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.vnsc-drawing-inspector__icon-cell--selected {\r\n\tbackground: var(--vnsc-bg-secondary, #222222);\r\n\tborder-color: var(--vnsc-accent, #2962ff);\r\n\tbox-shadow: 0 0 0 1px var(--vnsc-accent, #2962ff);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
